// import styles from "../../../styles/PatientList/patients.module.scss"
import styles from "../../../styles/components/input/search.module.scss"
import classNames from "classnames"
import { InputHTMLAttributes, useState } from "react"

interface FreeInputProps extends InputHTMLAttributes<HTMLInputElement> {
  name?
  label?
  value?
  error?
  onChange?
  onBlur?
  className?
  endAdornment?
  showEndAdornment?
  variant: "underlined" | "outlined"
  width?: "content" | "full"
  style?
  type?
  placeholder?: string
  autoFocus?: boolean

  [key: string]: unknown
}

const Input = (props: FreeInputProps) => {
  const {
    name,
    variant = "outlined",
    value = "",
    onChange,
    onBlur,
    className,
    endAdornment,
    showEndAdornment = false,
    disabled,
    width = "content",
    style,
    placeholder,
    autoFocus = false,
    type = "text",
    ...other
  } = props

  // focus needed for the animation
  const [hasFocus, setHasFocus] = useState(false)

  return (
    <div
      style={style}
      className={classNames(className, {
        [styles.isDisabled]: disabled,
        [styles.outlinedContainer]: variant === "outlined",
        [styles.underlinedContainer]: variant === "underlined",
        [styles.contentWidth]: width === "content",
        [styles.fullWidth]: width === "full",
        [styles.focus]: hasFocus,
      })}
    >
      {/*<label htmlFor={name}>{label}</label>*/}
      <input
        type={type}
        autoFocus={autoFocus}
        onChange={onChange}
        onBlur={(e) => {
          setHasFocus(false)
          if (onBlur) onBlur(e)
        }}
        onFocus={() => setHasFocus(true)}
        className={classNames({
          [styles.outlined]: showEndAdornment && variant === "outlined",
          [styles.outlinedWithoutAdornment]: !showEndAdornment && variant === "outlined",
          [styles.underlinedWithoutAdornment]: !showEndAdornment && variant === "underlined",
          [styles.underlined]: variant === "underlined",
        })}
        value={value}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        // autoFocus={true}
        {...other}
      />
      {showEndAdornment && (
        <div
          className={classNames({
            [styles.freeSearchEndAdornment]: showEndAdornment && variant === "outlined",
          })}
        >
          {!!endAdornment && endAdornment}
        </div>
      )}
    </div>
  )
}

export default Input
